function PageTitle({ title = '' }) {
  return <h1 className="text-left text-xl font-semibold mt-7 mb-5">{title}</h1>;
}

export default PageTitle;
